module.exports = __webpack_public_path__ + "img/gift2.c4a98028.png";